import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiConfigs } from "../../constants/apiConfigs";
import { ReferralsDataType } from "../../types/referrals/ReferralsTypes";
import { ERROR } from "../../constants/errors";
import { isFresh } from "../../utils/helpers";
import { fetchReferralsData } from "../../services/api/referral";

export interface ReferralSlice extends ReferralsDataType {
    loading: boolean,
    expired: boolean,
    last_fetched_at: number | null
}

export const initialState: ReferralSlice = {
    program: null,
    statistics: {
        total: 0,
        ig_connect: 0,
        eligible: 0,
        earnings: 0,
        currency: {code: "INR", symbol: "₹", locale: "en-IN"}
    },
    items: [],
    loading: false,
    last_fetched_at: null,
    expired: false,
}



const STALE_TIME = apiConfigs.FETCH_REFERRALS.staleTime;

export const fetchReferrals = createAsyncThunk(
    'referrals/fetch',
    async (force: boolean, {getState, rejectWithValue}) => {
        const state = getState() as {referrals: ReferralSlice};
        if(!force && isFresh(state.referrals.last_fetched_at, STALE_TIME) && !state.referrals.expired){
            return rejectWithValue(ERROR.CACHED);
        }
        try {
            const referralsData = await fetchReferralsData();
            return referralsData;
        } catch (error: any) {
            return rejectWithValue(ERROR.NOT_FOUND);
        }
    }
)

const referralSlice = createSlice({
    name: 'referrals',
    initialState,
    reducers: {
        markExpired: (state) => {
            state.expired = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchReferrals.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchReferrals.fulfilled, (state, data) => {
                state.loading = false;
                state.last_fetched_at = Date.now();
                state.program = data.payload.program;
                state.statistics = data.payload.statistics;
                state.items = data.payload.items;
                state.expired = false;
            })
            .addCase(fetchReferrals.rejected, (state, data) => {
                state.loading = false;
            })
    }
})

export const {markExpired} = referralSlice.actions;

export default referralSlice.reducer;


